<template>
    <div class="main-container px-5 py-5 xl:px-16">
        <div class="text-center p-4">
            <div v-if="loading" class="mb-4">
                <ProgressSpinner />
                <p>Processing your unsubscribe request...</p>
            </div>
            <div v-else-if="error" class="mb-4">
                <i class="pi pi-times-circle text-6xl text-red-500 mb-4"></i>
                <h1>Unsubscribe Failed</h1>
                <p class="text-lg">{{ error }}</p>
            </div>
            <div v-else>
                <i class="pi pi-check-circle text-6xl text-green-500 mb-4"></i>
                <h1>Successfully Unsubscribed</h1>
                <p class="text-lg mb-4">
                    You have successfully unsubscribed from receiving emails from Affiliation Space.
                </p>
                <p class="text-sm text-500">
                    If you change your mind, you can always update your preferences in your account settings.
                </p>
            </div>
            <Button 
                label="Return to Home" 
                class="mt-4" 
                @click="$router.push('/')"
            />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Button from 'primevue/button';
import ProgressSpinner from 'primevue/progressspinner';
import UsersService from '@/services/UsersService';

const route = useRoute();
const router = useRouter();
const loading = ref(true);
const error = ref(null);

onMounted(async () => {
    const { userId, type } = route.query;

    if (!userId) {
        error.value = 'Invalid unsubscribe link';
        loading.value = false;
        return;
    }

    try {
        await UsersService.unsubscribeFromEmails(userId, type);
        loading.value = false;
    } catch (err) {
        console.error('Unsubscribe error:', err);
        error.value = 'Failed to unsubscribe. Please try again or contact support.';
        loading.value = false;
    }
});
</script>

<style scoped>
.min-h-screen {
    min-height: 100vh;
}
</style> 